// extracted by mini-css-extract-plugin
export default {"stat":"Stat-module__stat___3Y999","label":"Stat-module__label___3EkAE","value":"Stat-module__value___3geqn"};